var render, staticRenderFns
import script from "./HorizontalBar.vue?vue&type=script&lang=js&"
export * from "./HorizontalBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/gcg3.devserver6.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287a5de8')) {
      api.createRecord('287a5de8', component.options)
    } else {
      api.reload('287a5de8', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/charts/HorizontalBar.vue"
export default component.exports